import styled from "@emotion/styled";
import { colors, customScroll, fontFamily, media, pxtorem } from "../../../assets/styles/theme";
import  managePlatformBottomBg from "../../../assets/images/managePlatformBottomBg.svg";
import iconClearFilter from "../../../assets/images/icon-filter-clear.svg";

export const ManagePlatFormWrapper = styled('div')`
     h1{
        max-width: 990px;
        margin-left: auto;
        margin-right: auto;
        ${media.lg`
            max-width: 100%;
            margin-left: 20px;
  `      }  
     }
`;

export const ManageContainer = styled('div')`
   border-radius: 12px;
   padding: 20px;
   max-width: 990px;
   margin: 0 auto 30px auto;
   background: ${colors.white};
   position: relative;
   ${media.lg`
     max-width: 100%;
     margin-left: 20px;
     margin-right: 20px;
  `}  
   &:after {
        content: '';
        position: absolute;
        width: 190px;
        height: 190px;        
        right: -148px;
        bottom: 15%;
        z-index: -1;
        background-image: url(${managePlatformBottomBg});
        background-position: 0 0;
        background-repeat: no-repeat; 
        ${media.lg`   
            right: -20px;
        `}     
    }
   .clientInfoOnlyBox {
      .MuiInputLabel-root {
         padding-left: 0;
         transform: none !important;
      }
      .MuiInput-root {
         font-weight: 500;
         &:before {
            border-bottom : none !important;
         }
      }
      .MuiInputBase-readOnly {
         margin-bottom: 4px;
         border: none;
         &:after {
           border-bottom-color: ${colors.white};
            transform: none;
         }
      }   
      
      .MuiFormLabel-root {
         font-size: ${pxtorem(11)};
         color: ${colors.secondaryText};
         margin-bottom: 8px;
         display: block;
      }
      .clientInfoInputBox{
         .MuiInputLabel-root {
            transform: translate(14px, -9px) scale(1) !important;
          }
      
      }
   }  
   .selectedDataSource {
      background-color: rgba(196, 216, 46, 0.1);    
      padding: 0 20px;
      margin: 0 -20px;
      .MuiInputLabel-root {
         background-color: transparent !important;
      }
   }
   .MuiAutocomplete-root {
      label.MuiInputLabel-root[data-shrink="false"] {
         max-width: calc(100% - 41px);
      }
   }
   .MuiTab-root {
    font-weight: 700;
    font-size: ${pxtorem(16)};
    line-height: 1.5;
    font-family: ${fontFamily.poppins};
    
   }
   .tabContainer {
      > .MuiBox-root {
         padding: 20px 0 0 0;
      }  
      .activeBorder {
         border-bottom: solid 1px ${colors.borderColor};
         
      }
   }
   .editPlatformLink[aria-disabled="true"]{
      pointer-events: none;
      opacity: 0.5;
   }

   .ManagePlaltFormFileUploadTable {      
      .tableColumn {
         margin-bottom: -65px;
         .btn-clearfilter {
            border-color: transparent !important;
            background-color: transparent !important;
            position: absolute;
            right: 10px;
            top: 3px;
            z-index: 99;
            font-size: 0;
            max-width: 60px;
            padding: 0;
            height: 20px;
           
            span.MuiButton-icon {
               margin: 0;
               &:after {
                  content: 'Clear';
                  width: ${pxtorem(50)};
                  height: ${pxtorem(20)};
                  color: ${colors.primaryMain};
                  text-transform: capitalize;
                  font-size: ${pxtorem(13)};
                  margin-left: -6px;
                  margin-top: 1px;
               }
             svg {
               fill: ${colors.primaryMain};
             }
            }
         }
      }
      .MuiTableHead-root {
         th:last-child {
            max-width: 100px;
            border-left: none;
            color: ${colors.white};
         }
      }
      .MuiTableBody-root {        
         .MuiTableCell-root{
            &:last-child {
               text-align: right;
               max-width: 100px;
               border-left: none;
               button[aria-label="edit"] {
                  visibility: none
               }
               .MuiPaper-root {
                  max-width: 195px;
                  display: flex;
               }
            }
         }
      }
      .MuiTablePagination-root {
         background-color: ${colors.white};
         border-bottom: solid 1px ${colors.borderColor};
         border-radius: 0;
         padding-bottom: 5px;
      }
      .MuiTableContainer-root{
         max-height: calc(100vh - 330px);
      }
      &.ResearchAndExperimentTable {
         .MuiTableBody-root {        
         .MuiTableCell-root{
            &:last-child {
               button[aria-label="edit"] {
                  visibility: visible;
                  img {
                     margin-left: 2px;
                  }
                  
               }
               button {
                  &[aria-label="download"] {
                     order: 1;
                  }
                  &[aria-label="edit"] {
                     order: 2;
                  }
                  &[aria-label="delete"] {
                     order: 3;
                  }
               }                  
            }
         }
      }
      }
   }
   
`;
